$(".filters-block__form > select").niceSelect();
$(".filters-block__calendar").datepicker({
  range: "period",
  dateFormat: "yy-mm-dd",
  firstDay: 1,
  dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
  showOtherMonths: true,
  selectOtherMonths: true,
  prevText: "",
  nextText: "",
  onSelect: function (dateText, inst, extensionRange) {
    $(".filters-block__startdate").val(extensionRange.startDateText);
    $(".filters-block__enddate").val(extensionRange.endDateText);
    let startDate = new Date(extensionRange.startDateText);
    let endDate = new Date(extensionRange.endDateText);
    let startDay = extensionRange.startDateText.slice(8);
    let endDay = extensionRange.endDateText.slice(8);
    let startMonth = startDate.toLocaleString("default", {
      month: "long",
    });
    let endMonth = endDate.toLocaleString("default", {
      month: "long",
    });
    let newStartDateFormat = startMonth + " " + startDay;
    let newEndDateFormat = endMonth + " " + endDay;

    if (extensionRange.startDateText !== extensionRange.endDateText) {
      $(".filters-block__calendar-input").text(
        newStartDateFormat + " - " + newEndDateFormat
      );
    } else {
      $(".filters-block__calendar-input").text(newStartDateFormat);
    }
  },
});

$("html").click(function (e) {
  if ($(e.target).hasClass("filters-block__calendar-input")) {
    $(".filters-block__calendar > .ui-datepicker-inline").toggle();
    $(".filters-block__calendar-input").toggleClass("opened");
  } else {
    if (!$(e.target).hasClass("ui-corner-all")) {
      $(".filters-block__calendar > .ui-datepicker-inline").hide();
      $(".filters-block__calendar-input").removeClass("opened");
    }
  }
});

$(".filters-block__calendar > .ui-datepicker-inline").hide();

$(".filters-block__more-options").click(function () {
  $(
    "div.filters-block__options_language,div.filters-block__options_participants"
  ).toggle();
  $(".filters-block__public-or-private").toggleClass("show");
  $(".filters-block").toggleClass("more");
  $(".filters-block__more-options")
    .toggleHtml(translations.moreOptions, translations.lessOptions)
    .toggleClass("less");
});



// WEBPACK FOOTER //
// ./scripts/modules/front-page-filters.js